<template>
  <b-container style="padding-top: 150px;">
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span>T</span
      ><span class="c4">erms and Conditions for D3rriana</span>
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c2">Effective Date: September 14, 2023</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c4">1. Acceptance of Terms</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c2"
        >By using D3rriana (the &quot;Platform&quot;), you agree to
        comply with and be bound by these Terms and Conditions
        (&quot;Terms&quot;). If you do not agree to these Terms, please do not
        use the Platform.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c4">2. Description of the Platform</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c2"
        >D3rriana is a platform designed to facilitate healthcare and
        caregiving by allowing families to download various apps to streamline
        caregiving processes, access games, and track data related to their
        loved ones. The Platform also aims to keep families connected through
        its services.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c4">3. User Eligibility</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c2"
        >You must be at least 18 years old or have the legal capacity to enter
        into a contract to use the Platform. By using the Platform, you
        represent and warrant that you meet these requirements.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c4">4. User Accounts</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c4">4.1. Account Creation:</span
      ><span class="c2"
        >&nbsp;To use certain features of the Platform, you may be required to
        create an account. You agree to provide accurate, current, and complete
        information during the registration process and to update such
        information to keep it accurate, current, and complete.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c4">4.2. Account Security:</span
      ><span class="c2"
        >&nbsp;You are responsible for maintaining the security of your account
        credentials and for any activities or actions under your account. You
        must notify us immediately if you suspect any unauthorized use of your
        account.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c3">5. User Content</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c4">5.1. User Responsibilities:</span
      ><span class="c2"
        >&nbsp;You are solely responsible for any content, data, or information
        you upload, submit, or transmit through the Platform (&quot;User
        Content&quot;). You agree that your User Content will not violate any
        applicable laws, regulations, or third-party rights.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c4">5.2. License: </span
      ><span class="c2"
        >By providing User Content on the Platform, you grant PonyEngine Inc. a
        worldwide, non-exclusive, royalty-free license to use, copy, reproduce,
        process, adapt, publish, transmit, distribute, and display such User
        Content for the purpose of providing and improving the Platform.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c3">6. Privacy</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c2"
        >Our Privacy Policy, which can be accessed on the Platform, explains how
        we collect, use, and protect your personal information. By using the
        Platform, you consent to the collection and use of your personal
        information as described in the Privacy Policy.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c3">7. Intellectual Property</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c4">7.1. Ownership:</span
      ><span class="c2"
        >&nbsp;PonyEngine Inc. retains all rights, title, and interest in and to
        the Platform and its content. You may not reproduce, distribute, modify,
        or create derivative works of the Platform without our express written
        consent.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c4">7.2. Trademarks:</span
      ><span class="c2"
        >&nbsp;PonyEngine Inc.&#39;s trademarks, service marks, and logos used
        on the Platform are the property of PonyEngine Inc.. You may not use
        these marks without our prior written permission.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c3">8. Disclaimers</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c4">8.1. No Medical Advice:</span
      ><span class="c2"
        >&nbsp;The information provided on the Platform is for general
        informational purposes only and should not be considered medical advice.
        Always consult with a qualified healthcare professional for medical
        advice and treatment.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c4">8.2. No Warranty:</span
      ><span class="c2"
        >&nbsp;The Platform is provided &quot;as is&quot; and &quot;as
        available&quot; without warranties of any kind, either express or
        implied, including, but not limited to, the implied warranties of
        merchantability, fitness for a particular purpose, or
        non-infringement.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c3">9. Limitation of Liability</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c2"
        >To the fullest extent permitted by applicable law, PonyEngine Inc.
        shall not be liable for any indirect, incidental, special,
        consequential, or punitive damages, or any loss of profits or revenues,
        whether incurred directly or indirectly, or any loss of data, use,
        goodwill, or other intangible losses resulting from (i) your use or
        inability to use the Platform, (ii) any unauthorized access to or use of
        our servers and/or any personal information stored therein, or (iii) any
        errors or omissions in the Platform&#39;s content.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c3">10. Governing Law</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c2"
        >These Terms shall be governed by and construed in accordance with the
        laws of California, without regard to its conflict of law
        principles.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c3">11. Changes to Terms</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c2"
        >PonyEngine Inc. reserves the right to modify or revise these Terms at
        any time. Any changes will be effective immediately upon posting on the
        Platform. Your continued use of the Platform after the posting of
        changes constitutes your acceptance of the revised Terms.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0"><span class="c3">12. Contact Information</span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c2"
        >If you have any questions or concerns about these Terms, please contact
        us at:</span
      >
    </p>
    <p class="c5 c1"><span class="c2"></span></p>
    <p class="c7">
      <span class="c2"
        >9461 Charleville Blvd. #888<br />Beverly Hills, CA 90212<br />hi@d3rriana.com<br />+1
        (323) 739-8664</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0 c1"><span class="c2"></span></p>
    <p class="c0">
      <span class="c2"
        >By using D3rriana, you acknowledge that you have read,
        understood, and agree to be bound by these Terms and Conditions.</span
      >
    </p>
    <p class="c0 c1"><span class="c2"></span></p>
  </b-container>
</template>

<script>
export default {
  name: "Policy_Terms"
};
</script>
